import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23fd6368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduce-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cr1" }, "友情链接", -1))
const _hoisted_3 = { class: "friendshipLink" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "hover" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleList, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "fz cr3 cp",
              key: item.id,
              href: item.source,
              target: "_blank"
            }, _toDisplayString(item.author), 9, _hoisted_4))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}